import { observable } from 'mobx'
import { CommonContainer, cartContainer } from 'src/models'
import { productState } from 'src/views/components/BaseProductComponent'
import { productDeps } from 'src/deps'
import { APPConfig } from 'config/appConfig'
import {
  checkMysiteOrPersonalOffer,
  enablePORedesignFeature,
  hasProductOfferPercentageDiscount,
} from 'src/utils/commonUtils'
class PromotionContainer extends CommonContainer {
  @observable subscriptionV2PromoResponse = {}

  getPostDataForPromoCall = (product = {}, productCount = 1) => {
    let postData = {
      productId: product.productId || '',
      categoryId: product.categoryId || '',
      type: product.type || 'DEFAULT',
      quantity: String(productCount || 1),
      // isSubscriptionIncludedInPromotion: true,
    }
    if (product.type == 'bundle' || product.type == 'kit') {
      const bundleData = productDeps?.getBundleData(product)
      postData = { ...postData, ...bundleData }
    } else {
      postData.skuId = product.skuId
    }
    return postData
  }

  resetV2PromoResponse = () => {
    this.subscriptionV2PromoResponse = {}
  }

  makeV2PromotionCall = async (product = {}, quantity = 1) => {
    const postData = this.getPostDataForPromoCall(product, quantity)
    const subscriptionPostData = {
      ...postData,
      isSubscriptionIncludedInPromotion: true,
      isSubscriptionPromotion: true,
      isCallMadeFromNewDesignPDP: true,
    }
    await this.makeSubscriptionPromoAPI(subscriptionPostData)
  }

  makeSubscriptionPromoAPI = async postData => {
    productState.quantityActionDisable = true
    const response = await cartContainer.makePromotionCall(postData)
    if (cartContainer.isSuccessResponse(response)) {
      this.subscriptionV2PromoResponse = response
    }
    productState.quantityActionDisable = false
  }

  hasMatchingPromotion(itemLevelPromotions = [], promotionTexts = []) {
    if (
      !Array.isArray(itemLevelPromotions) ||
      !Array.isArray(promotionTexts) ||
      promotionTexts.length === 0
    ) {
      return false
    }

    return itemLevelPromotions.some(promotionItem => {
      const breakup = promotionItem?.breakup
      if (!Array.isArray(breakup)) return false

      return breakup?.some(promotion => {
        const identifier = promotion?.identifier || ''
        if (!identifier) return false
        const identifierText = identifier?.replace(/_\d+$/, '').toLowerCase()

        return promotionTexts?.some(promoText =>
          identifierText?.includes(promoText?.toLowerCase?.())
        )
      })
    })
  }

  hasMySiteOfferSource(itemLevelPromotions = []) {
    if (!Array.isArray(itemLevelPromotions)) return false
    return itemLevelPromotions.some(promotionItem => {
      const breakup = promotionItem?.breakup
      if (!Array.isArray(breakup)) return false
      return breakup.some(
        b => b?.otherProperties?.offerSource === 'MySite'
      )
    })
  }

  checkSitePromotion() {
    if (!cartContainer || !APPConfig) return false

    const itemLevelPromotions = cartContainer.getItemLevelPromotions?.() || []

    // For Product Offer 2.0, hide the promo wallet only when the offer already
    // applies a percentage discount (e.g. "Offer Discount - 15% OFF"). The
    // percentage varies per promotion, so match the message pattern rather than
    // a fixed value. When no such offer discount is applied, keep the promo
    // wallet visible.
    const contextValue = checkMysiteOrPersonalOffer()
    if (contextValue === 'personal_offer' && enablePORedesignFeature()) {
      return hasProductOfferPercentageDiscount(cartContainer.cartResponse)
    }

    const hideSitePromotions =
      APPConfig?.getAppConfig()?.hidePromoWalletForAppliedPromotions || []
    return (
      this.hasMatchingPromotion(itemLevelPromotions, hideSitePromotions) ||
      this.hasMySiteOfferSource(itemLevelPromotions)
    )
  }
}

const promotionContainer = new PromotionContainer()

export { promotionContainer, PromotionContainer }
export default promotionContainer
